export const colors = {
  navy: '#133649',
  navyDark: '#0E2C3B',
  navyHero: '#1A4A66',
  navyMid: '#1d506b',
  slate: '#7E99AC',
  slateLight: '#9DB3C2',
  textBody: '#1d3a4a',
  textSecondary: '#51626d',
  textMuted: '#6d8294',
  textAccent: '#3a4f5c',
  green: '#4F8F52',
  greenLight: '#6FB877',
  greenMint: '#8FD49B',
  greenBg: '#E6F0E6',
  greenBgText: '#2f5e31',
  greenMuted: '#A7C7A8',
  gold: '#EDBD01',
  goldLight: '#F4D24A',
  amber: '#8A6A00',
  amberBg: '#FBF0CC',
  amberMark: '#C9A227',
  red: '#c0392b',
  redBg: '#FBEBE8',
  redBorder: '#f0c9c1',
  redDark: '#a82f22',
  bg: '#F4F7F9',
  surface: '#FFFFFF',
  border: '#E7EDF1',
  border2: '#EEF2F5',
  border3: '#DEE6EB',
  borderCheck: '#C2D0D9',
  borderDash: '#C7D4DD',
  rowSelected: '#E8EFF4',
  rowHover: '#F2F6F8',
  radiusCard: '22px',
  radiusHero: '26px',
  radiusModal: '24px',
  radiusPill: '24px',
  radiusTag: '9px',
  radiusCheck: '7px',
  radiusRow: '14px',
  radiusTable: '20px',
  radiusBulkBar: '18px',
  radiusBtn: '13px',
  shadowCard: '0 12px 30px -22px rgba(19,54,73,.25)',
  shadowHero: '0 26px 54px -30px rgba(14,44,59,.65)',
  shadowKpiGreen: '0 16px 30px -18px rgba(79,143,82,.55)',
  shadowKpiGold: '0 14px 26px -18px rgba(237,189,1,.5)',
  shadowBtn: '0 12px 24px -14px rgba(19,54,73,.55)',
  shadowBulk: '0 12px 26px -14px rgba(19,54,73,0.35)',
  shadowBulkRed: '0 12px 26px -14px rgba(192,57,43,0.4)',
  shadowBtnRed: '0 10px 20px -10px rgba(192,57,43,.55)',
} as const

export const themeColors = {
  primary: '#4176A4',
  lightPrimary: '#538ABA',
  secondary: '#7FA8CC',
  lightBlue: '#E8F3FB',
  lighterBlue: '#F6F9FB',
  backgroundBox: '#E8F3FB',
  background: '#FFFEFB',
  error: '#FF0C3E',
  accept: '#0D8612',
  white: '#FFFFFF',
  lightGray: '#BDBDBD',
  lighterGray: '#E1E1E1',
  paleGray: '#F1F1F1',
  gray: '#888888',
  gray1: '#333333',
  gray3: '#828282',
  gray4: '#535353',
  black: '#1D1B1B',
  blackInactive: 'rgba(0, 0, 0, 0.54)',
  blackHighEmphasis: 'rgba(0, 0, 0, 0.87)',
  garden: '#19A35F',
  primaryDark: '#0C2054',
  disabled: '#DADADA',
  yellow: '#F1901D',
  negative: '#EB5757',
  negativeHover: '#B91616',
  lightNegative: '#FEF3F3',
  success: '#219653',
  successHover: '#186C3C',
}

export const chartSeries = [
  '#1F6FA8',
  '#D9A800',
  '#2E8B57',
  '#D2699E',
  '#8A7A18',
  '#6A5AC8',
  '#E0762A',
  '#0E9C9C',
] as const

export const chartSeriesOther = '#8FA6B4'
